import axios from "axios";
import { buildPassengerRequest } from '../Services/BuildPassengerRequest';
import { buildCorporateTravellerProfileRequest } from '../Services/BuildCorporateTravellerProfileRequest';
import { PricingRequest } from '../Services/PricingRequest';

const REACT_APP_API = process.env.REACT_APP_API_BASE_URL;
const FlightAPI_BASE_URL = process.env.REACT_APP_FlightAPI_BASE_URL;



export const getAutoCity = async (query) => {
  try {
    const response = await axios.get(
      `${FlightAPI_BASE_URL}/api/Flight/GetAirports?SearchText=${query}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching city suggestions:", error);
    throw error;
  }
};

export const getAutoCountries = async () => {
  try {
    const response = await axios.get(
      `${REACT_APP_API}/api/Settings/GeographicalMaster/Countries`
    );
    return response.data; // should be an array of country objects
  } catch (error) {
    console.error("Error fetching countries:", error);
    return []; // return empty array on error to prevent crash
  }
};

export const GetCities = async (query) => {
  try {
    const response = await axios.get(
      `${REACT_APP_API}/api/Settings/GeographicalMaster/GetCities?SearchText=${query}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching countries:", error);
    return [];
  }
};

export const getAutoStation = async (query) => {
  // try {
  //   const response = await axios.get(
  //     `${FlightAPI_BASE_URL}/api/Flight/GetAirports?SearchText=${query}`
  //   );
  //   return response.data;
  // } catch (error) {
  //   console.error("Error fetching city suggestions:", error);
  //   throw error;
  // }
};

export const flightAvailability = (requestBody, onSupplierResult) => {
  //console.log("Calling Multiple Flight APIs...", requestBody);
  let suppliers = [];
  const API_URL = FlightAPI_BASE_URL + "/api/Flight/Availability";
  if(requestBody?.preferredCarrier === "6E"){
    suppliers = ["IndiGo"];
  }
  else if(requestBody?.preferredCarrier === "QP"){
    suppliers = ["AkasaAirCorporate"];
  }
  else{
    suppliers = ["IndiGo", "Tripjack", "Amadeus","AkasaAirCorporate"];
     //const suppliers = ["AkasaAirCorporate"];
  //const suppliers = ["IndiGo"];
  //const suppliers = ["Tripjack"];
  //suppliers = ["Amadeus"];
  }
 

  let completedSuppliers = 0;
  const totalSuppliers = suppliers.length;

  suppliers.forEach(async (supplier) => {
    try {
      const bodyWithSupplier = {
        ...requestBody,
        supplierCode: supplier,
      };

      const res = await axios.post(API_URL, bodyWithSupplier, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      const responseData = res.data;
      //console.log("All Data", responseData.result);
      let onward = [];
      let ret = [];

      /** ✅ Tripjack / TBO format (Round + One way) Domestic*/
      if (Array.isArray(responseData?.result)) {
        onward =
          responseData.result.find((x) => x.journey === "Onward")
            ?.flightAvailibility || [];

        ret =
          responseData.result.find((x) => x.journey === "Return")
            ?.flightAvailibility || [];
      }

      /** ✅ Tripjack / TBO format (Round + One way) International*/
      // if (Array.isArray(responseData?.result)) {

      //   const returnJourney = responseData.result.find(
      //     x => x.journey === "Return"
      //   );

      //   if (returnJourney?.flightAvailibility?.some(f => f.trip === 2)) {

      //     const internationalOnward =
      //       returnJourney.flightAvailibility.map(f => ({
      //         ...f,
      //         segments: f.segments?.filter(s => s.flightCount === 1)
      //       })) || [];

      //     const internationalReturn =
      //       returnJourney.flightAvailibility.map(f => ({
      //         ...f,
      //         segments: f.segments?.filter(s => s.flightCount === 2)
      //       })) || [];

      //     onward = internationalOnward;
      //     ret = internationalReturn;
      //   }
      // }


      /** ✅ Indigo (Direct array = One way) */
      if (Array.isArray(responseData)) {
        onward = responseData;
      }

      // Attach supplier name
      onward = onward.map((f) => ({ ...f, supplierCode: supplier }));
      ret = ret.map((f) => ({ ...f, supplierCode: supplier }));

      //console.log(`✔ ${supplier} → Onward: ${onward.length}, Return: ${ret.length}`);

      onSupplierResult({
        supplier,
        status: "done",
        onward,
        return: ret,
      });
    } catch (err) {
      console.error(`❌ ${supplier} failed`, err);

      onSupplierResult({
        supplier,
        status: "failed",
        onward: [],
        return: [],
      });
    } finally {
      completedSuppliers++;

      /** � VERY IMPORTANT */
      if (completedSuppliers === totalSuppliers) {
        onSupplierResult({
          allCompleted: true,
        });
      }
    }
  });
};

// export const flightAvailability = async (requestBody) => {
//   try {
//     //console.log("Calling Multiple Flight APIs...");

//     const API_URL = "https://localhost:7077/api/Flight/Availability";

//     const suppliers = ["Indigo"];

//     const results = await Promise.allSettled(
//       suppliers.map((supplier) =>
//         axios.post(
//           API_URL,
//           { ...requestBody, supplierCode: supplier },
//           {
//             headers: {
//               "Content-Type": "application/json",
//               Accept: "application/json",
//             },
//           }
//         )
//       )
//     );

//     let allOnward = [];
//     let allReturn = [];

//     results.forEach((res, i) => {
//       const supplier = suppliers[i];

//       if (res.status === "rejected") {
//         console.error("Failed supplier:", supplier);
//         return;
//       }

//       const data = res.value?.data?.result || [];

//       const onward = data.find((x) => x.journey === "Onward")?.flightAvailibility || [];
//       const ret = data.find((x) => x.journey === "Return")?.flightAvailibility || [];

//       onward.forEach((f) => allOnward.push({ ...f, supplierCode: supplier }));
//       ret.forEach((f) => allReturn.push({ ...f, supplierCode: supplier }));
//     });

//     return {
//       success: true,
//       onward: allOnward,
//       return: allReturn,
//     };
//   } catch (err) {
//     console.error("Multi API Error:", err);
//     throw err;
//   }
// };

// export const flightAvailability = async (requestBody) => {
//   //console.log("flightAvailability Url",FlightAPI_BASE_URL_2+"/api/Flight/Availability")
//   try {
//     const resp = await axios.post(
//       `${FlightAPI_BASE_URL_2}/api/Flight/Availability`,
//       requestBody, // ✅ Send JSON body
//       {
//         headers: {
//           "Content-Type": "application/json", //  Required
//           Accept: "application/json",
//         },
//       }
//     );
//     return resp.data;
//   } catch (err) {
//     console.error("flightAvailability error:", err);
//     throw err;
//   }
// };


export const flightPricing = async (clientCode, userID, key, agencyId, flight, Journey, ClassOfService, flightsListRequest) => {

  const requestBody = PricingRequest({ clientCode, userID, key, agencyId, flight, Journey, ClassOfService, flightsListRequest });
  //console.log("pricingRequst", requestBody)
  try {
    const resp = await axios.post(
      `${FlightAPI_BASE_URL}/api/Flight/Pricing`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
    return resp.data;
  } catch (err) {
    console.error("Pricing Error:", err);
    throw err;
  }
};

// export const GetCities = async (query) => {
//   try {
//     const response = await axios.get(
//       `${REACT_APP_API}/api/Settings/GeographicalMaster/GetCities?SearchText=${query}`
//     );
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching countries:", error);
//     return [];
//   }
// };


export const RetrieveSelectedFlight = async (params) => {
  try {
    const response = await axios.get(
      `${FlightAPI_BASE_URL}/api/Flight/RetrieveSelectedFlight`,
      {
        params: {
          ReferenceNo: params.ReferenceNo,
          ClientCode: params.ClientCode,
          Key: params.Key,
        },
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error fetching flight details:", error);
    throw error.response?.data || error;
  }
};

export const RetrieveAgentDetails = async (user) => {
  try {
    const response = await axios.get(
      `${REACT_APP_API}/api/Settings/AgencyDetails/AgencyDetails`,
      {
        params: {
          User: user,
        },
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error fetching agency details:", error);
    throw error.response?.data || error;
  }
};

export const RetrieveCorporateDetails = async (userName, corporateCode, emulateUser) => {
  //console.log("user",corporateCode);
  ////console.log("selectedUser",selectedUser);
  try {
    const response = await axios.get(
      `${REACT_APP_API}/api/Settings/CorporateDetails/GetCorporateDetails`,
      {
        params: {
          UserName : userName,
          CorporateCode: corporateCode,
          EmulateUser: emulateUser
        },
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error fetching agency details:", error);
    throw error.response?.data || error;
  }
};


export const GetOrganizationsType = async (user) => {
  try {
    const response = await axios.get(
      `${REACT_APP_API}/api/Settings/CorporateDetails/OrganizationsType`,
      {
        params: {
          User: user,
        },
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching Organizations Type:", error);
    throw error.response?.data || error;
  }
};

export const AddPassengerDetails = async ({ clientCode, key, referenceNo, contactDetails, travellers, ssrInfo, pricing, userName, seatSelections, selectedMeal, selectedBaggage, companyMarkup, customField }) => {
  const requestBody = buildPassengerRequest({ clientCode, key, referenceNo, contactDetails, travellers, ssrInfo, pricing, userName, seatSelections, selectedMeal, selectedBaggage, companyMarkup, customField });
  // debugger
  //console.log("BASE URL 2:", FlightAPI_BASE_URL);
  //console.log("AddPassengerDetails requestBody:", requestBody);
  try {
    const response = await axios.post(
      `${FlightAPI_BASE_URL}/api/Flight/AddPassengerDetails`,
      requestBody,
      {
        headers: {
          "Accept": "text/plain", // matches your curl
          "Content-Type": "application/json",
        },
      }
    );
    //console.log("AddPassengerDetails --> response:", response.data);
    return response.data;
  } catch (error) {
    console.error("AddPassengerDetails --> error:", error.response?.data || error.message);
    throw error;
  }
};

export const CreateCorporateTravellerProfile = async ({  contactDetails, travellers, userName ,corporateCode, product}) => {
  const requestBody = buildCorporateTravellerProfileRequest({  contactDetails, travellers, userName ,corporateCode, product});
  debugger
  //console.log("BASE URL 2:", REACT_APP_API);
  //console.log("AddPassengerDetails requestBody:", requestBody);
  try {
    const response = await axios.post(
      `${REACT_APP_API}/api/Account/CreateCorporateTravellerProfile`,
      requestBody,
      {
        headers: {
          "Accept": "text/plain", // matches your curl
          "Content-Type": "application/json",
        },
      }
    );
    //console.log("CreateCorporateTravellerProfile --> response:", response.data);
    return response.data;
  } catch (error) {
    console.error("CreateCorporateTravellerProfile --> error:", error.response?.data || error.message);
    throw error;
  }
};

export const CollectPayment = async (requestBody) => {
  //console.log("CollectPayment:", requestBody)
  //console.log("CollectPayment url:", `${REACT_APP_API}/api/Payment/CollectPayment`)
  try {
    const response = await axios.post(
      `${REACT_APP_API}/api/Payment/CollectPayment`,
      requestBody,
      {
        headers: {
          //"Accept": "text/plain", // matches your curl
          "Content-Type": "application/json",
        },
      }
    );
    //console.log("CollectPayment --> response:", response.data);
    return response.data;
  } catch (error) {
    console.error("CollectPayment --> error:", error.response?.data || error.message);
    throw error;
  }
};

// export const GetPaymentStatus = async (requestBody) => {
//   try {
//     const response = await axios.post(
//       `${REACT_APP_API}/api/Payment/GetHDfcPaymentOrderStatus`,
//        requestBody,
//       {
//         headers: {
//           //"Accept": "text/plain", // matches your curl
//           "Content-Type": "application/json",
//         },
//       }
//     );
//     //console.log("PaymentStatus --> response:", response.data);
//     return response.data;
//   } catch (error) {
//     console.error("PaymentStatus --> error:", error.response?.data || error.message);
//     throw error;
//   }
// };


export const FlightBooking = async (requestBody) => {
  try {
    const response = await axios.post(
      `${FlightAPI_BASE_URL}/api/Flight/Booking`,
      requestBody,
      {
        headers: {
          //"Accept": "text/plain", // matches your curl
          "Content-Type": "application/json",
        },
      }
    );
    //console.log("FlightBooking result:", response)
    return response.data;
  } catch (error) {
    console.error("FlightBooking --> error:", error.response?.data || error.message);
    throw error;
  }
};


export const FlightBookingDetails = async (requestBody) => {
  try {
    const response = await axios.post(
      `${FlightAPI_BASE_URL}/api/Flight/RetrieveBookingAll`,
      requestBody,
      {
        headers: {
          //"Accept": "text/plain", // matches your curl
          "Content-Type": "application/json",
        },
      }
    );
    //console.log("FlightBookingDetails --> response:", response.data);
    return response.data;
  } catch (error) {
    console.error("FlightBookingDetails --> error:", error.response?.data || error.message);
    throw error;
  }
};

export const FlightTransactionDetails = async (requestBody) => {
  try {
    const response = await axios.post(
      `${FlightAPI_BASE_URL}/api/Flight/BookingDetails`,
      requestBody,
      {
        headers: {
          //"Accept": "text/plain", // matches your curl
          "Content-Type": "application/json",
        },
      }
    );
    //console.log("FlightBookingDetails --> response:", response.data);
    return response.data;
  } catch (error) {
    console.error("FlightBookingDetails --> error:", error.response?.data || error.message);
    throw error;
  }
};


export const SeatSelection = async (requestBody) => {
  if (!requestBody || Object.keys(requestBody).length === 0) {
    throw new Error("SeatSelection requires a non-empty requestBody");
  }

  //console.log("SeatSelection requestBody:", requestBody);

  try {
    const response = await axios.post(
      `${FlightAPI_BASE_URL}/api/Flight/SeatAvailability`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    //console.log("Seat Availability response:", response.data);

    // Return Response if present, otherwise return full data
    return response.data?.Response || response.data;
  } catch (error) {
    // Log detailed error including validation messages
    const apiError = error.response?.data || error.message;
    console.error("Seat Availability API error:", apiError);

    if (error.response?.data?.errors) {
      console.table(error.response.data.errors); // Show validation issues
    }

    throw apiError;
  }
};

export const SpecialService = async (requestBody) => {
  try {
    const response = await axios.post(
      `${FlightAPI_BASE_URL}/api/Flight/SpecialService`,
      requestBody,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    //console.log("Special Service response:", response.data);
    return response.data;

  } catch (error) {
    console.error(
      "Special Service error:",
      error?.response?.data || error.message
    );
    throw error;
  }
};

export const GetSeatAvailability = async (requestBody) => {
  try {
    //console.log("AXIOS FINAL PAYLOAD:", requestBody); 

    const response = await axios.post(
      `${FlightAPI_BASE_URL}/api/Flight/SeatAvailability`,
      requestBody, 
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Seat Availability error:",
      error?.response?.data || error.message
    );
    throw error;
  }
};

export const getAutoAirlines = async (query) => {
  try {
    const response = await axios.get(
      `${FlightAPI_BASE_URL}/api/Flight/GetAirlines`,
      {
         params: {
          searchText: query,
          searchType: ""
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching Auto Airlines:", error);
    return [];
  }
};

export const FlightFareRule = async (requestBody) => {
  try {
    const response = await axios.post(
      `${FlightAPI_BASE_URL}/api/Flight/FareRule`,
      requestBody,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    return response.data; // keep this
  } catch (error) {
    console.error(
      "Fare Rule error:",
      error?.response?.data || error.message
    );
    throw error;
  }
};


export const FlightMiniFareRule = async (requestBody) => {
  try {
    const response = await axios.post(
      `${FlightAPI_BASE_URL}/api/Flight/MiniFareRule`,
      requestBody,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    return response.data; // keep this
  } catch (error) {
    console.error(
      "Mini Fare Rule error:",
      error?.response?.data || error.message
    );
    throw error;
  }
};



export const CancelBooking = async (requestBody) => {
  try {
    const response = await axios.post(
      `${FlightAPI_BASE_URL}/api/Flight/CancelBooking`,
      requestBody,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    //console.log("CancelBooking response:", response.data);
    return response.data;
  } catch (error) {
    console.error(
      "CancelBooking error:",
      error?.response?.data || error.message
    );
    throw error;
  }
};



export const RescheduleRequest = async (requestBody) => {
  try {
    const response = await axios.post(
      `${FlightAPI_BASE_URL}/api/Flight/AddRescheduleRequest`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    //console.log("RescheduleRequest : response:", response.data);
    return response.data;
  } catch (error) {
    console.error("RescheduleRequest : error:", error.response?.data || error.message);
    throw error;
  }
};

export const WhatsAppRequest = async (requestBody) => {
  try {
    const response = await axios.post(
      `${FlightAPI_BASE_URL}/api/Flight/WhatsAppRequest`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    //console.log("WhatsApp Request : response:", response.data);
    return response.data;
  } catch (error) {
    console.error("WhatsApp Request : error:", error.response?.data || error.message);
    throw error;
  }
};

export const EmailRequest = async (requestBody) => {
  try {
    const response = await axios.post(
      `${FlightAPI_BASE_URL}/api/Flight/EmailRequest`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    //console.log("Email Request : response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Email Request : error:", error.response?.data || error.message);
    throw error;
  }
};


export const SmsRequest = async (requestBody) => {
  try {
    const response = await axios.post(
      `${FlightAPI_BASE_URL}/api/Flight/SmsRequest`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    //console.log("Sms Request : response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Sms Request : error:", error.response?.data || error.message);
    throw error;
  }
};


export const GetProfileDetails = async (user) => {
  try {
    const response = await axios.get(
      `${REACT_APP_API}/api/Settings/CorporateDetails/GetProfileDetails`,
      {
        params: {
          User: user,
        },
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error fetching agency details:", error);
    throw error.response?.data || error;
  }
};


export const GetCorporateDetails = async (userName) => {
  try {
    const response = await axios.get(
      `${REACT_APP_API}/api/Settings/CorporateDetails/GetCorporates`,
      {
        params: {
          userName: userName,
        },
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data.corporateList;
  } catch (error) {
    console.error("Error fetching corporate details:", error);
    throw error.response?.data || error;
  }
};

export const GetCorporateDetailsAvailableBalance = async (corporateCode) => {
  try {
    const response = await axios.get(
      `${REACT_APP_API}/api/Settings/CorporateDetails/GetCorporatesAvailableBalance`,
      {
        params: {
          corporateCode: corporateCode,
        },
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data.corporateBalance;
  } catch (error) {
    console.error("Error fetching corporate details:", error);
    throw error.response?.data || error;
  }
};

export const GetCorporateDetailsForBilling = async (userName) => {
  try {
    const response = await axios.get(
      `${REACT_APP_API}/api/Settings/CorporateDetails/GetCorporatesForBilling`,
      {
        params: {
          userName: userName,
        },
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data.corporateList;
  } catch (error) {
    console.error("Error fetching corporate details:", error);
    throw error.response?.data || error;
  }
};

export const GetTravellersByCorporateCode = async (corporateCode) => {
  try {
    const response = await axios.get(
      `${REACT_APP_API}/api/Settings/CorporateDetails/GetTravellersByCorporateCode`,
      {
        params: { CorporateCode: corporateCode },
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data.corporateList;
  } catch (error) {
    console.error("Error fetching travellers:", error);
    throw error.response?.data || error;
  }
};


export const GetCountriesList = async () => {
  try {
    const response = await axios.get(
      `${REACT_APP_API}/api/Settings/GeographicalMaster/Countries`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    // ✅ Correct key
    return response.data.countries;

  } catch (error) {
    console.error("Error fetching countries:", error);
    throw error.response?.data || error;
  }
};

export const SendFlightBookingNotifications = async (requestBody) => {
  //console.log("requestBody", requestBody);
  try {
    const response = await axios.post(
      `${FlightAPI_BASE_URL}/api/Utility/SendFlightBookingNotifications`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    //console.log("SendFlightBookingNotifications --> response:", response.data);
    return response.data;
  } catch (error) {
    console.error("SendFlightBookingNotifications --> error:", error.response?.data || error.message);
    throw error;
  }
};


export const TicketDownload = async (requestBody) => {
  //console.log("requestBody", requestBody);
  try {
    const response = await axios.get(
      `${FlightAPI_BASE_URL}/api/Utility/GenerateETicket`,
      {
        params: {
          referenceNo: requestBody.referenceNo,
          trackID: requestBody.trackId,
          type: requestBody.type
        },
        responseType: "blob",
      }
    );
    return response;
  } catch (error) {
    console.error("Error fetching agency details:", error);
    throw error.response?.data || error;
  }
};


export const GetAllOrganizations = async () => {
  try {
    const response = await axios.get(
      `${REACT_APP_API}/api/Organization/CorporateDetails/AllOrganizations`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching Organizations Type:", error);
    throw error.response?.data || error;
  }
};

export const GetAllCompany = async (req) => {
  //console.log("req", req);
  try {
    const response = await axios.get(
      `${REACT_APP_API}/api/Organization/CorporateDetails/AllCompanies`,
      {
        params: {
          CorporateCode: req.corporateCode,
          CorporateType: req.corporateType
        },
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching Organizations Type:", error);
    throw error.response?.data || error;
  }
};

export const GetAllLegalEntity = async (req) => {
  //console.log("req", req);
  try {
    const response = await axios.get(
      `${REACT_APP_API}/api/Organization/CorporateDetails/AllLegalEntities`,
      {
        params: {
          companyCode: req.companyCode,
          CorporateType: ""
        },
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching Organizations Type:", error);
    throw error.response?.data || error;
  }
};


export const SaveApprovalLowFareFlights = async (requestBody) => {
  //console.log("SaveApprovalLowFareFlights requestBody", requestBody);
  try {
    const response = await axios.post(
      `${FlightAPI_BASE_URL}/api/Flight/SaveLowFareFlights`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    //console.log("SaveOnwardSortedFlights --> response:", response.data);
    return response.data;
  } catch (error) {
    console.error("SaveOnwardSortedFlights --> error:", error.response?.data || error.message);
    throw error;
  }
};


// Frequent Flyer start

export const ManageFrequentFlyer = async (requestBody) => {
  try {
    const response = await axios.post(
      `${REACT_APP_API}/api/Organization/Flight/ManageFrequentFlyerNo`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    //console.log("ManageFrequentFlyer result:", response.data);
    return response.data;
  } catch (error) {
    console.error(
      "Manage Frequent Flyer Error:",
      error.response?.data || error.message
    );

    throw error;
  }
};

export const FrequentFlyerList = async (userName) => {
  try {
    const response = await axios.post(
      `${REACT_APP_API}/api/Organization/Flight/GetFrequentFlyersNo`,
      {},
      {
        params: {
          userName: userName
        },
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    console.log(
      "FrequentFlyerList Result:",
      response?.data
    );
    return response?.data || {};
  } catch (error) {
    console.error(
      "FrequentFlyerList Error:",
      error?.response?.data || error.message
    );
    return {};
  }
};

export const DeleteFrequentFlyer = async (
  id,
  userName
) => {

  try {

    const response = await axios.post(
      `${REACT_APP_API}/api/Organization/Flight/DeleteFrequentFlyerNo`,
      {},
      {
        params: {
          id: id,
          userName: userName
        },
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    console.log(
      "DeleteFrequentFlyer Result:",
      response?.data
    );

    return response?.data || {};

  } catch (error) {

    console.error(
      "DeleteFrequentFlyer Error:",
      error?.response?.data || error.message
    );

    return {};
  }
};

export const TravelPolicies = async (requestBody) => {
  try {
    const response = await axios.post(
      `${REACT_APP_API}/api/TravelPolicy/TravelPolicies`,
      requestBody,
      {
        headers: {
          //"Accept": "text/plain", // matches your curl
          "Content-Type": "application/json",
        },
      }
    );
    //console.log("Travel Policies result:", response)
    return response.data;
  } catch (error) {
    console.error("Travel Policies --> error:", error.response?.data || error.message);
    throw error;
  }
};

export const GetTravelDocuments = async (requestBody) => {
  try {
    const response = await axios.post(
      `${REACT_APP_API}/api/Reservations/home/GetTravelDocuments`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Get Travel Documents Error:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const UploadDocument = async (request) => {
  try {
    const formData = new FormData();

    formData.append("ReferenceNo", request.ReferenceNo);
    formData.append("ProductType", request.ProductType);
    formData.append("DocumentType", request.DocumentType);
    formData.append("Document", request.Document);
    formData.append("CreatedBy", request.CreatedBy);

    const response = await axios.post(
      `${REACT_APP_API}/api/Reservations/home/AddTravelDocument`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Upload Document Error:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const GetFrequentFlyersNoByAirline = async (username, airlineCode) => {
  try {
    const response = await axios.post(
      `${REACT_APP_API}/api/Organization/Flight/GetFrequentFlyersNoByAirline`,
      null,
      {
        params: {
          userName: username,
          airlineCode: airlineCode,
        },
      }
    );
    return response.data.frequentFlyersNoByAirline;
  } catch (error) {
    console.error("Error fetching corporate details:", error);
    throw error.response?.data || error;
  }
};